<script setup>

import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import {onMounted} from "vue";
import ContactForm from "@/components/ContactForm.vue";
import {useHead} from "@vueuse/head";

onMounted(() => {
  const scripts = [
    '/static/js/jquery-3.6.0.min.js',
    '/static/js/bootstrap.min.js',
    '/static/js/popper.min.js',
    '/static/js/magnific-popup.min.js',
    '/static/js/slick.min.js',
    '/static/js/counterup.min.js',
    '/static/js/waypoints.min.js',
    '/static/js/jquery-ui-min.js',
    '/static/js/jquery.nice-select.min.js',
    '/static/js/theia-sticky-sidebar.min.js',
    '/static/js/main1.js'
  ];

  function loadScriptsSequentially(scripts, index = 0) {
    if (index < scripts.length) {
      const script = document.createElement('script');
      script.src = scripts[index];
      script.onload = () => loadScriptsSequentially(scripts, index + 1);
      document.body.appendChild(script);
    }
  }

  loadScriptsSequentially(scripts);
})

useHead({
  title: 'Aluminum Window Exporter',
  meta: [
    {
      name: 'keywords',
      content: 'Aluminum Window Exporter'
    },
    {
      name: 'description',
      content: 'Upgrade your home with stunning aluminum windows for a touch of class.'
    }
  ]
})
</script>

<template>
  <Header/>
  <div class="lt-breadcrumb">
    <div class="breadcrumb-content">
      <div class="container">
        <div class="d-flex justify-content-between">
          <div class="title">
            <h1>Contact Us</h1>
          </div>
          <ol class="breadcrumb align-self-center">
            <li class="breadcrumb-item"><a href="/">Home</a></li>
            <li class="breadcrumb-item active" aria-current="page">Contact Us</li>
          </ol>
        </div>
      </div><!-- /.container -->
    </div><!-- /.breadcrumb-content -->
  </div><!-- /.lt-breadcrumb -->

  <div class="lt-page-content bg-color">
    <div class="lt-section">
      <div class="section-content lt-contact section-padding">
        <div class="container">
          <div class="row">
            <div class="col-md-4">
              <div class="contact-info bg-white">
                <div class="icon">
                  <i class="fa fa-volume-control-phone" aria-hidden="true"></i>
                </div>
                <span>+86 13923140282</span>
              </div>
            </div>

            <div class="col-md-4">
              <div class="contact-info bg-white">
                <div class="icon">
                  <i class="fa fa-envelope-open-o" aria-hidden="true"></i>
                </div>
                <span><a href="mailto:example@mail.com">dongxia52587@gmail.com</a></span>
              </div>
            </div>

            <div class="col-md-4">
              <div class="contact-info bg-white">
                <div class="icon">
                  <i class="fa fa-map-o" aria-hidden="true"></i>
                </div>
                <span>No. 1 Wanguo Market, Mashe Village, Lishui Town, Nanhai, Foshan, Guangdong, China</span>
              </div>
            </div>

            <div class="col-md-7 col-lg-8">
              <div class="get-in-touch">
                <h3>Get In Touch</h3>
                <ContactForm/>
              </div>
            </div>
          </div>
        </div><!-- container -->
      </div><!-- lt-agent-details -->
    </div><!-- lt-section -->


  </div><!-- /.lt-page-content -->


  <Footer/>
</template>

<style scoped lang="scss">

</style>